import { EdizioneObj } from './../../classes/edizione-obj';
import { Component, ElementRef, HostListener, NgZone, OnInit, SecurityContext, ViewChild } from '@angular/core';
import { directus, Edizione, Progetto } from "../../../../directus";
import { ActivatedRoute, Router } from "@angular/router";
import { CommonModule, formatDate } from "@angular/common";
import { aggregate, readItem, readItems, createItem, uploadFiles, deleteFile, updateItem, deleteItem } from "@directus/sdk";
import { AppComponent } from '../../app.component';
import { BaseComponent } from '../base/base.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { CanvasBadgeComponent } from '../canvas-badge/canvas-badge.component';
import { FormBuilder, Validators, FormsModule, ReactiveFormsModule, FormArray, NG_VALUE_ACCESSOR, FormControl, FormGroup } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { faEye, faEnvelope, faPrint, faCheck, faSearch, faPencil, faUser, faUsers } from '@fortawesome/free-solid-svg-icons';
import { environment } from '../../../environments/environment';
import { IscrizioneObj } from '../../classes/iscrizione-obj';
import { count } from 'rxjs';

@Component({
  selector: 'app-progetto',
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, FormsModule, ReactiveFormsModule, CanvasBadgeComponent],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ProgettoComponent,
      multi: true
    }
  ],
  templateUrl: './progetto.component.html',
  styleUrl: './progetto.component.css'
})
export class ProgettoComponent extends BaseComponent implements OnInit {
  progetto: Progetto | undefined;
  edizioni: EdizioneObj[] | undefined;
  lastEd: EdizioneObj | undefined;
  _currentEd: any = null;

  sanitizedValue: string = '';
  submitted = false;

  @ViewChild('badgeLoader', { static: false }) badgeLoader: ElementRef | undefined;
  private _fileBadge: File | null = null;
  imagePreview: string | undefined;

  @ViewChild(CanvasBadgeComponent, { static: false })
  badge_component!: CanvasBadgeComponent;

  @ViewChild(CanvasBadgeComponent, { static: false })
  badge_componentBadge!: CanvasBadgeComponent;

  @HostListener('change', ['$event.target.files']) emitFiles(event: FileList) {
    //const file = event && event.item(0);
    //this._fileBadge = file;

    //alert('HostListener');
  }
  faEye: any;
  faEnvelope: any;
  faPrint: any;
  faCheck: any
  faSearch: any;
  faPencil: any;
  faUser: any;
  faUsers: any;

  public badge: FormControl | undefined;
  public validExt = 'jpg';
  isModalBadgeOpen: boolean = false;
  formBadge!: FormGroup;

  constructor(protected override router: Router, private route: ActivatedRoute, private app: AppComponent, private readonly _formBuilder: FormBuilder, private sanitizer: DomSanitizer, private host: ElementRef<HTMLInputElement>, public zone: NgZone) {
    super(router);
    this.layoutGrid = false;

    this.faEye = faEye;
    this.faEnvelope = faEnvelope;
    this.faPrint = faPrint;
    this.faCheck = faCheck;
    this.faSearch = faSearch;
    this.faPencil = faPencil;
    this.faUser = faUser;
    this.faUsers = faUsers;
  }
  async ngOnInit(): Promise<void> {
    if (this.route.snapshot.paramMap.get('id')) {
      const _id = this.route.snapshot.paramMap.get('id');
      if (_id) {
        await this.getProgettoById(_id);
        if (this.progetto && this.progetto != undefined) {
          const _idP = Number(this.progetto.id);
          if (this.progetto?.colore) {
            this._bgColor = this.getBackgroundAlpha(this.progetto?.colore);
          }
          this.getAllEdizioni(_idP);
        }
        this.initFormEdizione();
        this.initFormBadge();

      } else {
        alert(' Progetto non trovato!');
      }
    }
  }
  async getProgettoById(id: string) {
    //@ts-ignore
    this.progetto = await directus
      .request<Progetto>(readItem('progetti', id));
    //console.log("ProgettoComponent.getProgettoById(" + id + "):  ", this.progetto);

    //this.lastEd = await directus.request<Edizione>(readItem('edizione', {
    //  aggregate: { max: 'numero' },
    //  fields: ["id", "status", "numero", "nome", "descrizione", "inizio", "fine", "progetto", "badge"]
    //}));
    //console.log("lastEd:  ", this.lastEd);
    //
    //this.edizione = await directus
    //  .request<Edizione>(readItem("edizione", id));
    //
    //const result = await directus.request<Edizione[]>(
    //  readItems('edizione', {
    //    sort: ['-fine'], //Sort by sort field and creation date descending
    //  })
    //
    //console.log("lastEd:  " , this.lastEd);
  }
  /*EDIZIONI*/
  nuovaEdizione() {
    this.setCurrentEd(null);
    this.setFormEdizione();
    this.openModal();
  }
  setCurrentEd(_ed: any) {
    this._currentEd = _ed;
  }
  getCurrentId() {
    return this._currentEd;
  }
  openEdizione(_ed: Edizione) {
    if (!_ed || _ed.id <= 0) {
      alert('No edizione');
      return;
    }
    const self = this;
    this.setCurrentEd(_ed)

    self.zone.run(async () => {
      self.openModal();
      setTimeout(() => {
        self.setFormEdizione();
        if (self.badge_component != undefined)
          self.badge_component.reinitBage();
        //self.badge_component.setBadgeURL(environment.apiUrl + environment.presence_subscription_route);
      }, 100);
    });
  }
  get fb() {
    return this.formBadge.controls;
  }
  initFormEdizione() {
    var currentDate = formatDate(new Date(), 'yyyy-MM-ddTHH:mm', 'it');
    this.badge = new FormControl('', [Validators.required, requiredFileType(this.validExt)] as Validators);

    this.form = this._formBuilder.group({
      status: ['0', Validators.required],
      nome: [this.progetto?.nome + ' - ', Validators.required],
      descrizione: [''],
      inizio: [currentDate, [Validators.required]],
      fine: [currentDate, [Validators.required]],
      badge: this.badge
      /*
        b_font_size: number = 80;
        bw: number = 2500;
        bh: number = 3500;
        tx: number= 1550;
        ty: number = 2920;
        qrcode_w: number = 350;
        qrcode_h: number = 350;
        qrcode_x: number = 1550;
        qrcode_y: number = 3150;
      */
    });
  }
  setFormEdizione() {
    this.form.markAsPristine();
    this.form.markAsUntouched();
    if (this.isCurrentEdizione()) {

      this.form.controls['status'].reset({ value: (this._currentEd ? this._currentEd.status : ''), disabled: false });
      this.form.controls['status']?.updateValueAndValidity();

      this.form.controls['nome'].reset({ value: (this._currentEd ? this._currentEd.nome : this.progetto?.nome + ' - '), disabled: false });
      this.form.controls['nome']?.updateValueAndValidity();

      this.form.controls['descrizione'].reset({ value: (this._currentEd ? this._currentEd.descrizione : ''), disabled: false });
      this.form.controls['descrizione']?.updateValueAndValidity();

      this.form.controls['inizio'].reset({ value: (this._currentEd.inizio ? this._currentEd.inizio : new Date()), disabled: false });
      this.form.controls['inizio']?.updateValueAndValidity();

      this.form.controls['fine'].reset({ value: (this._currentEd.fine ? this._currentEd.fine : new Date()), disabled: false });
      this.form.controls['fine']?.updateValueAndValidity()

      this.form.controls['badge']?.clearValidators();
      this.form.controls['badge']?.updateValueAndValidity();
      //this.form.controls['badge'].reset({ value: '', disabled: false });

      //if (this.badgeLoader)
      //  this.badgeLoader.nativeElement.value = null;
    } else {

      var currentDate = formatDate(new Date(), 'yyyy-MM-ddTHH:mm', 'it');

      this.form.controls['status'].reset({ value: '0', disabled: false });
      this.form.controls['status']?.updateValueAndValidity();

      this.form.controls['nome'].reset({ value: this.progetto?.nome + ' - ', disabled: false });
      this.form.controls['nome']?.updateValueAndValidity();

      this.form.controls['descrizione'].reset({ value: '', disabled: false });
      this.form.controls['descrizione']?.updateValueAndValidity();

      this.form.controls['inizio'].reset({ value: currentDate, disabled: false });
      this.form.controls['inizio']?.updateValueAndValidity();

      this.form.controls['fine'].reset({ value: currentDate, disabled: false });
      this.form.controls['fine']?.updateValueAndValidity()

      this.form.controls['badge']?.setValidators([Validators.required, requiredFileType(this.validExt)]);
      this.form.controls['badge']?.updateValueAndValidity();
      this.form.controls['badge'].reset({ value: '', disabled: false });
      //if (this.badgeLoader)
      //  this.badgeLoader.nativeElement.value = null;
    }

  }
  onSelectBadge(event: Event) {
    const self = this;
    if (event != null && event.target != null) {
      this._fileBadge = (event.target as HTMLInputElement).files[0];
      const reader = new FileReader();
      reader.onload = () => {
        //alert('FILE LOADED');
        self.app.hideSpinner();
      };
      self.app.showSpinner();

      reader.readAsDataURL(this._fileBadge);
    }
  }
  isCurrentEdizione(): boolean {
    if (!this.getCurrentId() || this.getCurrentId() == null || this.getCurrentId() == undefined)
      return false;

    return true;
  }
  async onSubmit() {
    const { status, nome, descrizione, inizio, fine, badge } = this.form.value;

    //alert("submit " + status + ' ' + nome + ' ' + descrizione + ' ' + inizio + ' ' + fine + ' ' + badge);
    const self = this;
    try {

      if (this.form.valid) {
        this.app.showSpinner();

        //AGGIORNAMENTO
        if (this._currentEd != null) {
          let _currentBadgeId = this._currentEd.badge;
          self._currentEd.nome = nome;
          self._currentEd.descrizione = descrizione;
          self._currentEd.inizio = inizio;
          self._currentEd.fine = fine;

          //NUOVO FILE BADGE
          if (badge && badge.length > 0) {
            this.uploadBadgeFile(self._fileBadge).then(async (r: any) => {
              if (r && r.id)
                self._currentEd.badge = r.id;

              self.updateEdizione(self._currentEd).then((r: any) => {
                if (r && r.id) {
                  if (self.edizioni && self.edizioni != undefined){
                    Object.assign(self.edizioni[self.edizioni.findIndex(el => el.id === r.id)], new EdizioneObj(r));
                  }
                  self.app.hideSpinner();
                }
                self.submitted = true;
              });
              //DELETE VECCHIO FILE
              if ( _currentBadgeId ){
                await directus.request(deleteFile(_currentBadgeId))
              };

              self.closeModal();
            });
          }
          //MANTENGO IL FILE BADGE
          else {
            this.updateEdizione(self._currentEd).then((r: any) => {
              if (r && r.id) {
                if (self.edizioni && self.edizioni != undefined)
                  Object.assign(self.edizioni[self.edizioni.findIndex(el => el.id === r.id)], new EdizioneObj(r));
                self.app.hideSpinner();
              }
              self.submitted = true;
            });
          }
          self.closeModal();
        } //NUOVO
        else {
          if (!self._fileBadge) {
            alert('badge non trovato!');
            return;
          }
          this.uploadBadgeFile(self._fileBadge).then((result: any) => {
            if (!result && !result.id) {
              alert('Upload badge fallito!');
              return;
            }
            const _values = {
              status: status,
              nome: nome,
              descrizione: descrizione,
              inizio: inizio,
              fine: fine,
              progetto: this.progetto?.id,
              badge: result.id,
              b_font_size: environment.b_font_size,
              bw: environment.bw,
              bh: environment.bh,
              tx: environment.tx,
              ty: environment.ty,
              qrcode_w: environment.qrcode_w,
              qrcode_h: environment.qrcode_h,
              qrcode_x: environment.qrcode_x,
              qrcode_y: environment.qrcode_y
            }
            self.saveNuovaEdizione(_values).then((r: any) => {
              if (r && r.id) {
                self.edizioni?.push(new EdizioneObj(r));
              }
              self.submitted = true;
              self.app.hideSpinner();
              self.closeModal();
            });
          });
        }
      }
    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      console.error(error);
      this.print_error = error;
      this.app.hideSpinner();
    }
  }

  async saveNuovaEdizione(_ed: any): Promise<any> {
    try {
      return  directus.request<Edizione>(createItem('edizione', _ed));
    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      console.error(error);
      this.print_error = error;
      return null;
    }
  }
  async updateEdizione(_ed: EdizioneObj): Promise<any> {
    try {
      const _edizione = {
        status: Number( _ed.status),
        nome: _ed.nome,
        descrizione: _ed.descrizione,
        inizio: _ed.inizio,
        fine: _ed.fine,
        progetto: _ed.progetto,
        badge: _ed.badge,
        b_font_size: Number( _ed.b_font_size ),
        bw: Number( _ed.bw ),
        bh: Number( _ed.bh ),
        tx: Number( _ed.tx ),
        ty: Number( _ed.ty ),
        qrcode_w: Number( _ed.qrcode_w ),
        qrcode_h: Number( _ed.qrcode_h ),
        qrcode_x: Number( _ed.qrcode_x ),
        qrcode_y: Number( _ed.qrcode_y )
      } // extract the property `a` and keep the other properties in `otherProperties`

      return directus
        .request<Edizione>(updateItem('edizione', _ed.id, _edizione));
    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      console.error(error);
      this.print_error = error;
      return null;
    }
  }
  async uploadBadgeFile(raw_file: any): Promise<any> {
    const formData = new FormData();
    //formData.append('title', 'badge-' + this.progetto?.id);// + '-' + _ed.id );
    formData.append('folder', '267258ec-b229-4075-8d92-13dcd8dfdaf5');
    formData.append('file', raw_file);


    return directus.request(uploadFiles(formData));
  }
  /*EDIT BADGE*/
  initFormBadge() {
    this.formBadge = this._formBuilder.group({
      b_font_size: [ environment.b_font_size],
      bw: [ environment.bw],
      bh: [ environment.bh],
      tx: [ environment.tx],
      ty: [ environment.ty],
      qrcode_w: [ environment.qrcode_w],
      qrcode_h: [ environment.qrcode_h],
      qrcode_x: [ environment.qrcode_x],
      qrcode_y: [ environment.qrcode_y],
    });
  }
  setFormBadge() {
    this.formBadge.markAsPristine();
    this.formBadge.markAsUntouched();
    if (this.isCurrentEdizione()) {

      this.formBadge.controls['b_font_size'].reset({ value: (this._currentEd ? this._currentEd.b_font_size : ''), disabled: false });
      this.formBadge.controls['b_font_size']?.updateValueAndValidity();

      this.formBadge.controls['bw'].reset({ value: (this._currentEd ? this._currentEd.bw : ''), disabled: false });
      this.formBadge.controls['bw']?.updateValueAndValidity();

      this.formBadge.controls['bh'].reset({ value: (this._currentEd ? this._currentEd.bh : ''), disabled: false });
      this.formBadge.controls['bh']?.updateValueAndValidity();

      this.formBadge.controls['tx'].reset({ value: (this._currentEd.tx ? this._currentEd.tx : new Date()), disabled: false });
      this.formBadge.controls['tx']?.updateValueAndValidity();

      this.formBadge.controls['ty'].reset({ value: (this._currentEd.ty ? this._currentEd.ty : new Date()), disabled: false });
      this.formBadge.controls['ty']?.updateValueAndValidity();

      this.formBadge.controls['qrcode_w'].reset({ value: (this._currentEd.qrcode_w ? this._currentEd.qrcode_w : environment.qrcode_w ), disabled: false });
      this.formBadge.controls['qrcode_w']?.updateValueAndValidity();

      this.formBadge.controls['qrcode_h'].reset({ value: (this._currentEd.qrcode_h ? this._currentEd.qrcode_h : environment.qrcode_h ), disabled: false });
      this.formBadge.controls['qrcode_h']?.updateValueAndValidity();

      this.formBadge.controls['qrcode_x'].reset({ value: (this._currentEd.qrcode_x ? this._currentEd.qrcode_x : environment.qrcode_x ), disabled: false });
      this.formBadge.controls['qrcode_x']?.updateValueAndValidity();

      this.formBadge.controls['qrcode_y'].reset({ value: (this._currentEd.qrcode_y ? this._currentEd.qrcode_y : environment.qrcode_y ), disabled: false });
      this.formBadge.controls['qrcode_y']?.updateValueAndValidity();

    }
  }
  onChangeQrW(event: any) {
    this.formBadge.controls['qrcode_h']?.reset({ value: event.target.value, disabled: false });
  }
  onChangeQrH(event: any) {
    const _h = event.target.value;
    //this.formBadge.controls['qrcode_w']?.reset({ value: _h, disabled: false });
    //if (this.formBadge.controls['bh'].value < (this.formBadge.controls['qrcode_y'].value + this.formBadge.controls['qrcode_h']?.value)) {
    //  this.formBadge.controls['qrcode_y'].reset({ value: (this.formBadge.controls['bh']?.value - this.formBadge.controls['qrcode_h']?.value ), disabled: false });
    //}
  }

  onChangeQrY(event: any) {
    const _h = event.target.value;
    //if (this.formBadge.controls['bh'].value < ( _h + this.formBadge.controls['qrcode_h']?.value)) {
    //  this.formBadge.controls['qrcode_y'].reset({ value: (this.formBadge.controls['bh']?.value - this.formBadge.controls['qrcode_h']?.value), disabled: false });
    //}
  }
  onSubmitBadge() {

    const { b_font_size, bw, bh, tx, ty, qrcode_w, qrcode_h, qrcode_x, qrcode_y } = this.formBadge.value;
    const self = this;
    try {

      if (this.formBadge.valid) {
        this.app.showSpinner();

        //AGGIORNAMENTO
        if (this._currentEd != null) {
          let _currentBadgeId = this._currentEd.badge;

          self._currentEd.b_font_size = Number( b_font_size );
          self._currentEd.bw = Number( bw );
          self._currentEd.bh = Number( bh );
          self._currentEd.tx = Number( tx );
          self._currentEd.ty = Number( ty );
          self._currentEd.qrcode_w = Number( qrcode_w );
          self._currentEd.qrcode_h = Number( qrcode_h );
          self._currentEd.qrcode_x = Number( qrcode_x );
          self._currentEd.qrcode_y = Number(qrcode_y);
          const _badge = self.badge_componentBadge;
          self.zone.run(async () => {
            self.updateEdizione(self._currentEd).then((r: any) => {
              if (r && r.id) {
                if (self.edizioni && self.edizioni != undefined)
                  Object.assign(self.edizioni[self.edizioni.findIndex(el => el.id === r.id)], new EdizioneObj(r));
                self.app.hideSpinner();
                _badge.setEdizioneByObject(self._currentEd, true);
              }
              self.submitted = true;
            });
            //self.closeModalBadge();
          });
        } else {
          alert("impossibile aggiornare il badge ");
          return;
        }
      }
    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      console.error(error);
      this.print_error = error;
      this.app.hideSpinner();
    }
  }
  editBadge(_ed: EdizioneObj) {
    if (!_ed || _ed.id <= 0) {
      alert('Nessuna edizione selezionata');
      return;
    }

    const self = this;
    this.setCurrentEd(_ed)
    let _badge = self.badge_componentBadge;

    self.zone.run(async () => {
      self.app.showSpinner();

      self.openModalBadge();
      setTimeout(() => {
        self.setFormBadge();
        if (self.badge_componentBadge != undefined) {
          self.badge_componentBadge.setPreviewHeight("h-96");
          self.badge_componentBadge.reinitBage();
          self.app.hideSpinner();
        }
        //self.badge_componentBadge.setBadgeURL(environment.apiUrl + environment.presence_subscription_route);
      }, 100);
    });
  }
  /*UTILITY*/
  sanitizeInput(value: any) {
    const sanitizedValue = this.sanitizer.sanitize(
      SecurityContext.HTML,
      value
    );
    this.sanitizedValue = sanitizedValue ? sanitizedValue.toString() : '';
  }
  goToEdizione(id: Number) {
    this.router.navigate(['/edizione', id]);
  }
  getEditionDate(edizione: Edizione) {
    if (edizione && edizione.inizio && edizione.fine) {
      const _edObj = new EdizioneObj(edizione);
      return _edObj.getEditionDate()
    }
    return '';
  }
  async deleteEdizione(_edizione: EdizioneObj) {
    if (_edizione && _edizione.id) {
      if (confirm('Eliminare ' + _edizione.nome + ' ?')) {
        //alert('delete ' + _edizione.nome);
        //DELETE VECCHIO FILE
        if (_edizione.badge)
          directus.request(deleteFile(_edizione.badge));

        const result = await directus.request(deleteItem('edizione', _edizione.id));
        let index = this.edizioni?.findIndex(d => d.id === _edizione.id); //find index in your array
        if (index != undefined && index!=null && index >= 0)
          this.edizioni?.splice(index, 1)
      }
    } else {
      alert('Edizione non trovata');
    }
  }
  async getAllEdizioni(_id: number) {
    const self = this;
    try {
      //@ts-ignore
      this.edizioni = await directus
        .request<Edizione[]>(readItems("edizione", {
          sort: ['-inizio'],
          filter: {
            "progetto": {
              "_eq": _id,
            }
          },
          fields: ["id", "status", "nome", "descrizione", "inizio", "fine", "badge", "progetto", "b_font_size", "bw", "bh", "tx", "ty", "qrcode_w", "qrcode_h", "qrcode_x", "qrcode_y"]
        }));
      if( this.edizioni != undefined )
        this.lastEd = new EdizioneObj(this.edizioni[0]);

      self.analizzaEdizioni();

    } catch (error: any) {
      error = JSON.parse(JSON.stringify(error));
      if (error && error != undefined) {
        if (error.errors[0].extensions.code === 'FORBIDDEN') {
          self.app.logOut();
        }
      }
      console.error(error);

    }
  }
  analizzaEdizioni() {
    if (this.edizioni && this.edizioni.length > 0) {
      const self = this;
      this.edizioni.forEach(async (_edizione: EdizioneObj) => {


        let _filter: any = {
          "edizione": {
            "_eq": _edizione.id
          }
        };

        const iscritti = await directus.request(
          aggregate('iscrizioni', {
            query: {
              filter: _filter,
            },
            aggregate: {
              count: ['id'],
            }
          }),
        );

        _filter = null;
        _filter = {
          "edizione": {
            "_eq": _edizione.id
          },
          "confermata": {
            "_eq": "1",
          },
        };

        const confermati = await directus.request(
          aggregate('iscrizioni', {
            query: {
              filter: _filter,
            },
            aggregate: {
              count: ['id'],
            }
          }),
        );

        _filter = null;
        _filter = {
          "edizione": {
            "_eq": _edizione.id
          },
          "presenza": {
            "_eq": "1",
          },
        };

        const presenti = await directus.request(
          aggregate('iscrizioni', {
            query: {
              filter: _filter,
            },
            aggregate: {
              count: ['id'],
            }
          }),
        );
        if (iscritti && iscritti.length > 0 && iscritti[0].count.id)
          _edizione.iscrizioni = Number(iscritti[0].count.id);
        if (confermati && confermati.length > 0 && confermati[0].count.id)
          _edizione.confermati = Number(confermati[0].count.id);
        if (presenti && presenti.length > 0 && presenti[0].count.id)
          _edizione.presenti = Number(presenti[0].count.id);

        console.log('Edizione ' + _edizione.nome + ' iscritti: ' + iscritti[0].count.id + ' confermati: ' + confermati[0].count.id + ' presenti: ' + presenti[0].count.id);
        });
    }
  }
  closeModalBadge() {
    this.isModalBadgeOpen = false;
  }
  public openModalBadge() {
    this.isModalBadgeOpen = true;
  }
  override openModal() {
    super.openModal();
  }


  override closeModal() {
    super.closeModal()
  }
}
export function requiredFileType(type: string) {
  return function (control: FormControl) {
    const file = control.value;
    if (file) {
      var fileExt = file.split('.').pop();
      // const extension = file.split('.')[1].toLowerCase();
      if (type.toLowerCase() !== fileExt.toLowerCase()) {
        return {
          requiredFileType: true
        };
      }

      return null;
    }

    return null;
  };
}
export function dateValidator(c: FormControl) {
  // Not sure if c will come in as a date or if we have to convert is somehow
  const today = new Date();
  if (c.value > today) {
    return null;
  } else {
    return { dateValidator: { valid: false } };
  }
}
